"use client";

import { useEffect } from "react";

export default function JsonLdServicesListScript() {
    useEffect(() => {
        const jsonLd = {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "PT Mubarokah Digital Nusantara",
            "alternateName": "Mubarokah Digital Creative Agency",
            "url": `${process.env.NEXT_PUBLIC_APP_URL}/services`,
            "logo": `${process.env.NEXT_PUBLIC_APP_URL}/logo.png`,
            "description": "Digital Creative Agency providing comprehensive digital solutions for businesses",
            "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Digital Agency Services",
                "itemListElement": [
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Basic Package - Monthly",
                            "description": "Profitable beginner and MSME packages",
                            "url": `${process.env.NEXT_PUBLIC_APP_URL}/services/`,
                        },
                        "priceSpecification": {
                            "@type": "UnitPriceSpecification",
                            "price": "1490000",
                            "priceCurrency": "IDR",
                            "billingIncrement": 1,
                            "unitCode": "MON",
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Business Package - Monthly",
                            "description": "Package includes creating a logo, branding, and website.",
                            "url": `${process.env.NEXT_PUBLIC_APP_URL}/services/`,
                        },
                        "priceSpecification": {
                            "@type": "UnitPriceSpecification",
                            "price": "3499000",
                            "priceCurrency": "IDR",
                            "billingIncrement": 1,
                            "unitCode": "MON",
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Custom Package - Monthly",
                            "description": "Customizable package to suit specific needs.",
                            "url": `${process.env.NEXT_PUBLIC_APP_URL}/services/`,
                        },
                        "priceSpecification": {
                            "@type": "UnitPriceSpecification",
                            "price": "0",
                            "priceCurrency": "IDR",
                            "billingIncrement": 1,
                            "unitCode": "MON",
                            "eligibleQuantity": {
                                "@type": "QuantitativeValue",
                                "value": "Contact for custom pricing"
                            }
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Basic Package - Annual",
                            "description": "Profitable beginner and MSME packages with annual discount.",
                            "url": `${process.env.NEXT_PUBLIC_APP_URL}/services/`,
                        },
                        "priceSpecification": {
                            "@type": "UnitPriceSpecification",
                            "price": "16986000",
                            "priceCurrency": "IDR",
                            "billingIncrement": 1,
                            "unitCode": "ANN",
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Business Package - Annual",
                            "description": "Includes logo creation, branding, and website with annual discount.",
                            "url": `${process.env.NEXT_PUBLIC_APP_URL}/services/`,
                        },
                        "priceSpecification": {
                            "@type": "UnitPriceSpecification",
                            "price": "39888600",
                            "priceCurrency": "IDR",
                            "billingIncrement": 1,
                            "unitCode": "ANN",
                        }
                    },
                    {
                        "@type": "Offer",
                        "itemOffered": {
                            "@type": "Service",
                            "name": "Custom Package - Annual",
                            "description": "Customizable package with annual pricing.",
                            "url": `${process.env.NEXT_PUBLIC_APP_URL}/services/`,
                        },
                        "priceSpecification": {
                            "@type": "UnitPriceSpecification",
                            "price": "0",
                            "priceCurrency": "IDR",
                            "billingIncrement": 1,
                            "unitCode": "ANN",
                            "eligibleQuantity": {
                                "@type": "QuantitativeValue",
                                "value": "Contact for custom pricing"
                            }
                        }
                    }
                ]
            },
            "address": {
                "@type": "PostalAddress",
                "addressCountry": "ID",
                "addressLocality": "Indonesia"
            },
            "sameAs": [
                "https://www.facebook.com/mubarokah.co.id/",
                "https://www.instagram.com/mubarokahdotcom/",
                "https://x.com/mubarokah_id/",
                "https://www.linkedin.com/company/mubarokah/"
            ]
        };

        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.dataset.type = "services-list-jsonld";
        script.text = JSON.stringify(jsonLd);
        document.head.appendChild(script);

        return () => {
            const existingScript = document.querySelector(
                'script[data-type="services-list-jsonld"]'
            );
            if (existingScript) {
                existingScript.remove();
            }
        };
    }, []);

    return null;
}
